import { Component, inject, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { OnboardingStatus } from 'src/app/core/enum/OnboardingStatus';
import { SignInPayload } from 'src/app/core/models/auth/SignInPayload';
import { AuthService } from 'src/app/core/services/auth';
import { SharedService } from 'src/app/core/services/shared';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SignInComponent extends BaseComponent implements OnInit {
  authService = inject(AuthService);
  sharedService = inject(SharedService);
  formGroup = this.buildForm();

  isTryingToSignIn = false;

  showPassword = false;
  appName = this.sharedService.GetAppName();
  ngOnInit(): void {
    this.buildForm();
  }

  onSubmit(): void {
    if (this.formGroup.invalid) {
      this.notification.info('Preencha os campos corretamente.');
      return;
    }

    this.signInRequest();
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  private signInRequest(): void {
    const loaderRef = this.loader.open('Entrando...');

    this.authService
      .signIn(this.getSignInPayload())
      .pipe(this.takeUntilDestroyed())
      .subscribe(() => this.signInSuccess())
      .add(() => loaderRef.close());
  }

  private signInSuccess(): void {
    const onboardingStatus = this.authService.onboardingStatus$.getValue();

    this.notification.success(`Bem vindo(a) ao Hub!`);

    const redirectUrl = this.getRouteQueryParam('redirectTo');

    if (redirectUrl) {
      this.router.navigateByUrl(redirectUrl);
      return;
    }

    if (onboardingStatus === OnboardingStatus.Finalizado) {
      this.router.navigate(['dashboard']);
      return;
    }

    if (onboardingStatus !== OnboardingStatus.NaoIniciado) {
      this.router.navigate(['onboarding']);
      return;
    }

    this.router.navigate(['onboarding', 'bem-vindo']);
  }

  private getSignInPayload(): SignInPayload {
    const form = this.formGroup.getRawValue();
    return {
      email: form.email,
      senha: form.password,
    };
  }

  private buildForm() {
    return this.fb.nonNullable.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }
}
